/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { createContext, useContext } from "react";
import { BLoCBase } from "./classes/BLoCBase";
import { BLoCCallback } from "./types/BLoCCallback";
import { IBLoC } from "./types/IBLoC";

export const createBLoC = <T extends IBLoC & BLoCBase<any>>(blocInit?: Readonly<T>) => {
  type t = Readonly<Omit<T, "onInit" | "onDestroy" | "unsub">>;
  const Context = createContext(Object.freeze(blocInit));
  type Params = { bloc: Readonly<T> } & BLoCCallback<Readonly<T>>;
  const ContextWrapper: React.FC<Params> = ({ children, bloc }) => (
    <Context.Provider value={bloc}>
      {!bloc ? null : typeof children === "function" ? (children as Function)(bloc) : children}
    </Context.Provider>
  );
  return [ContextWrapper, () => useContext<t>(Context as any)] as [React.FC<Params>, () => t];
};
